<template>
	<div class="row">
		<div class="col-12 my-2 mb-5">
			<label class="text-muted">Covid-19 vaccination certificate*</label>
			<VaxCardUploader type="vaxcard" @uploadComplete="updateVaxInfo" />
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VaxCardUploader from './VaxCardUploader.vue';
Vue.use(VueToast);

const fb = require("../firebaseConfig")

export default {
	name: "VaxxForm",
	components: {
		VaxCardUploader
	},
	props:["orderData"],
    computed:{
		confId(){
            return this.$store.state.confId
        },
		confInfo(){
            return this.$store.state.confInfo
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
		isFormValid(){
			const {
				imgFile, imgFileName
			} = this.register
			if(!imgFile || !imgFileName){
				return false;
			}
            return true
        }
    },
    data(){
        return{
			isBusy: false,
			register:{},
		}
    },
    methods:{
		updateVaxInfo(vaxInfo){
			const {register, orderData} = this;
			register.imgFile = vaxInfo.imgFile;
			register.imgFileName = vaxInfo.imgFileName;
			this.isBusy = true;
			fb.ordersCollection.doc(orderData.id).update(register).then(()=>{
				Vue.$toast.success("Vaccination information updated.", {position:"top"})
				this.isBusy = false;
			}).catch((error) => {
				console.error("Error writing document: ", error);
				this.isBusy = false;
			})
			fb.adminEmailCollection.add({
				to: "secretariat@districtconference.com",
				message:{
					subject: `${orderData.data.fname} ${orderData.data.lname} - Vaccination information updated`,
					html:`<p>Dear Team,</p>
					<p>${orderData.data.fname} ${orderData.data.lname} has updated their vaccination information.</p>
					<p>View: <a href="${register.imgFile}">${register.imgFile}</a></p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p>&nbsp;</p>
					<p><hr/></p>
					<p style="font-size:10px;">${this.confInfo.confhost}</p>`,
				},
			}).then(()=>{
				this.isBusy = false;
			}).catch((error) => {
				console.error("Error writing document: ", error);
				this.isBusy = false;
			})
		},
    },
    mounted(){
		if(this.orderData) this.$store.dispatch("fetchConfProfile", this.orderData.data.confeventid);
    }
}
</script>
